import React, { createContext, useContext } from 'react';
import { Text as RNText, StyleSheet } from 'react-native';
import { useTheme } from '../../theme';
import { applyBrandFont, withCapCentring } from '../../design/typography';

// True inside another Text: nested text without its own weight inherits the
// parent's font (e.g. a bold sentence keeps its bold inner words).
const NestedTextContext = createContext(false);

/**
 * Themed Text component that automatically applies theme-aware text color
 * This is a proxy for React Native's Text component with default theming.
 * Text renders in Sofia Pro; fontWeight picks the matching Sofia Pro family.
 */
const Text = ({ style, children, ...props }) => {
	const { theme } = useTheme();
	const isNested = useContext(NestedTextContext);

	// Create default themed style
	const defaultStyle = {
		color: theme.ui.colors.text,
	};

	// Merge default style with provided style
	const mergedStyle = style ? [defaultStyle, style] : defaultStyle;
	const shouldInheritFont = isNested && !StyleSheet.flatten(style)?.fontWeight;
	// Nested text is drawn by its parent, which carries the cap centring.
	const resolvedStyle = shouldInheritFont
		? mergedStyle
		: applyBrandFont(mergedStyle, theme.ui.areBrandFontsLoaded);
	const drawnStyle = isNested ? resolvedStyle : withCapCentring(resolvedStyle);
	const hasElementChildren = typeof children !== 'string' && typeof children !== 'number' && children !== null && children !== undefined;

	return (
		<RNText style={drawnStyle} {...props}>
			{
				hasElementChildren ? (
					<NestedTextContext.Provider value={true}>
						{children}
					</NestedTextContext.Provider>
				) : children
			}
		</RNText>
	);
};

export default Text;
